import React, { useState,useRef, useCallback } from 'react';
import { Button, OverlayTrigger, Popover, Modal } from 'react-bootstrap'
import ReactGA from 'react-ga';
import "react-datepicker/dist/react-datepicker.css";
import ReCAPTCHA from 'react-google-recaptcha';
import Swal from 'sweetalert2';

export default function HomePage(props) {
    const [modalShow, setModalShow] = useState(true);

    const [captchaResponse, setCaptchaResponse] = useState(true);
        const [validationResponse, setValidationResponse] = useState(true);
        const [verificationResponse, setVerificationResponse] = useState(false);
        const [capchaToken, setCapchaToken] = useState('');
        const recaptchaRef = useRef(null);
        const [validToken, setValidToken] = useState('');
    
        const handleRecaptcha = useCallback((token) => {
            setCapchaToken(token || '');
    
            if(token.length > 0) {
                var captchaWidget = document.getElementById('captchaV');
                captchaWidget.style.border = '';
    
                setCaptchaResponse(true);
                setValidationResponse(true);
                setVerificationResponse(false);
    
                verifyCaptcha(token);
            }
        }, []);

    function onClickNext(referral = null) {


        //START Google Captcha
        
        var captchaWidget = document.getElementById('captchaV');
        if (validToken.length == 0) {
            // reCAPTCHA not verified, add red border and prevent form submission

            captchaWidget.style.border = '2px solid #e3342f';
            setCaptchaResponse(false);

             Swal.fire({
                title: 'Oops...',
                icon: 'error',
                text: 'Please verify Captcha.'
            });

            return false;
        } 

        if(verificationResponse == false)
        {

            return false;

        }
        //END Google Captcha

         if(referral) {
            window.location.href = " /critical-safe?r="+referral;
        } else {
             window.location.href = "/critical-safe";

        }

       
    }
    
     function verifyCaptcha(token) {
       // if(!isEmpty(token))
        //{    
           
            setValidToken(token);

            var captchaWidget = document.getElementById('captchaV');

            captchaWidget.style.border = '';

            axios.post('/api/get-captcha', {
                response: token
            }).then(function (response) {
                    
                    let cresponse = response.data;
                    if(cresponse.success == true) {
                        setValidationResponse(true);
                        setVerificationResponse(true);
                       // grecaptcha.reset();
                    } else {
                        setValidationResponse(false);
                        setVerificationResponse(false);

                        Swal.fire({
                            title: 'Oops...',
                            icon: 'error',
                            text: 'Captcha verification Failed. Please try again.'
                        });

                        return false;
                    }
            }).catch(function (error) {
                    console.log(error);
            });
        //}

    }

    ReactGA.initialize('UA-144246801-1');
    return (
        <>
            <section id="header" className="d-flex align-items-center">
                <div className="row text-white">
                    <div className="col-12 col-sm-8 ml-sm-5">
                        <h2>Your beacon of support when Critical Illness strikes</h2>
                        {/* <p>
                            Supporting you and your loved ones when critical illness strikes
                        </p> */}
                    </div>
                </div>
            </section>
            <section id="body">
                <div className="container">
                    <div className="row shadow title mt-n5 position-relative justify-content-center">
                        {/* <div className="col-4 col-sm-2 align-self-center text-right py-3">
                            <img src="../images/bicycle-icon.png" alt="Bicycle Insurance" width={120} />
                        </div> */}
                        <div className="col-12 col-sm-12 text-center">
                            <h2 className="m-5 text-white font-weight-bold">Critical Illness Insurance</h2>
                        </div>
                    </div>
                    <div className="row content">
                        <div className="col-1"></div>
                        <div className="col-10 shadow bg-white rounded">
                            <div className="row text-primary">
                                <div className="col-12 mt-1 text-center">
                                    {/* <h5 className="text-primary font-weight-bold my-3">Affordable Online Critical Illness Insurance</h5> */}
                                    <p>
                                    The Critical Illness Insurance is made simplified for you to get covered in the event of being diagnosed with critical illnesses such as cancer, heart attack or stroke.                          
					 </p>
                                </div>
                            </div>
                            <div className="row my-3">
                                <div className="col-12 mt-1 text-center">
                                    <h5 className="text-primary font-weight-bold mb-3">COVERAGE AND FEATURES AT A GLANCE</h5>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary mr-2"></i>
                                        No medical check-up required
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary mr-2"></i>
                                        Flexi choices of Top 2 or Top 5 Critical Illness
                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary mr-2"></i>
                                        Early Stage Cover
    					 <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                    You can add-on coverage for early stage of the Top 5 critical illnesses. Get the treatment needed to ensure that the disease does not get worse! Not applicable to Top 2 CI.

                                                        </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                                        </OverlayTrigger>

                                    </p>
                                    <p className="text-secondary">
                                        <i className="fas fa-check-circle text-primary mr-2"></i>
                                        Diabetic Care Disease
					     <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                    Add-on coverage for diabetic complications with additional standalone Sum Insured of up to RM50,000. Not applicable to Top 2 CI.
                                                    </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                            <i className="fa fa-question-circle text-primary ml-2" aria-hidden="true"></i>
                                        </OverlayTrigger>
                                    </p>
                                   
                                    
                                </div>
                            </div>
                               <div className="col-12 text-center">
                                            <p className="pdpa small">
                                                By clicking 'Get Quote' button, you have read and agreed to our <a target="_blank" href={process.env.MIX_INSTAPOL_DOMAIN + "/privacy-policy"}>Privacy Policy</a>
                                            </p>
                                        </div>

                                {/* START Google Captcha Verification */}
                                <div className="col-12 text-center mb-3">
                                        <center>

                                       
                                        <ReCAPTCHA id="captchaV" ref={recaptchaRef} sitekey={process.env.MIX_GOOGLE_CAPTCHA_SITE_KEY} onChange={handleRecaptcha}/>

                                        <small id="verify-alert" className={(captchaResponse == true) ? 'd-none': 'text-danger'}>Please verify Captcha. </small>
                                        <small id="response-alert" className={(validationResponse == true) ? 'd-none': 'text-danger'}>Captcha verification Failed. Please try again. </small>
                                        <small id="gcresponse-success" className={(verificationResponse == true) ? 'text-success font-weight-bold': 'd-none'}>Verification Success.</small>
                                        </center>
                                </div>
                        </div>
                        <div className="col-1"></div>
                    </div>
                    <div className="row footer text-center mt-n2">
                        <div className="col-12">
			  
                           
			  
                            {props.referral ?
                                <button type="button" class="btn btn-success" onClick={() => { onClickNext(props.referral) }}>Get Quote</button>
                                // <a href={`/critical-safe?r=${props.referral}`} className="btn btn-success">Get Quote</a>
                            :   
                                <button type="button" class="btn btn-success" onClick={() => { onClickNext() }}>Get Quote</button>
                            }
                                    
                            <PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} />
                        </div>
                        <div className="row d-flex d-sm-none mt-3">
                            <div className="col-12 text-center">
                                <small>* Terms and conditions apply.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pds text-white mt-5">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="my-4 font-weight-bold">Please refer to the policy contract for more information on the benefits provided.</p>
                            </div>
                        </div>
                        <div className="row pds-row my-5">
				<div className="col-12 col-sm-6">
                                <a href="storage/pdf/pds.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/pdf-icon.png" alt="ProductTermsConditions.pdf" className="img" width={100} />
                                    </div>
                                     Tune Protect Critical Safe+<br></br>
                                     (Product Disclosure Sheets)
                                </a>
                            </div>

                            <div className="col-12 col-sm-6">
                                <a href="storage/pdf/pw.pdf" target="_blank" className="text-white text-decoration-none">
                                    <div className="pdf-icon">
                                        <img src="../images/pdf-icon.png" alt="ProductDisclosure.pdf" className="img" width={100} />
                                    </div>
                                    Tune Protect Critical Safe+<br></br>
                                     (Policy Wording)
                                </a>
                            </div>
                        </div>
                    
                        <div className="row text-center justify-content-around">
                            <p className="col-8 font-weight-bold mt-2">
                                Underwritten by Tune Insurance Malaysia Berhad Company No.: 197601004719 (30686-K)
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

function PromptConfirmation(props) {
    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Body style={{ padding: 0, position: 'relative' }}>
            <button
                type="button"
                className="close"
                onClick={props.onHide}
                aria-label="Close"
                style={{ position: 'absolute', top: '10px', right: '10px', zIndex: '1' }}
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <a href="https://instapol.my/" target="_blank">
                <img
                    src={"../images/240112_Motor insurance-01.jpg"}
                    alt="Full-Sized Image"
                    className="img-fluid modal-image"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </a>
        </Modal.Body>
    </Modal>
    
    );
}
